import { Directive, Input, Output, ElementRef, EventEmitter } from '@angular/core';
import getFormat from './config';

declare var jQuery: any;

@Directive({
  selector: '[chDatepicker]',
})
export class DatepickerDirective {
  private dateFormat: string = 'DD/MM/YYYY';

  @Output() onChange: EventEmitter<any> = new EventEmitter();
  @Input() public date: string;
  @Input() public minDate: string;
  @Input() public datetime: boolean;
  @Input() public monthOnly: boolean;
  private ele: ElementRef;
  private value: string;

  private $ele;

  constructor(ele: ElementRef) {
    this.ele = ele;
  }

  ngAfterViewInit() {
    this.dateFormat = getFormat(this.datetime, this.monthOnly);
    const config = {
      format: this.dateFormat,
      // the library requires a value of false when there is no valid date
      minDate: this.minDate || false
    };

    // Add month-only specific configuration
    if (this.monthOnly) {
      config['viewMode'] = 'months';
    }

    this.$ele = jQuery(this.ele.nativeElement);
    this.$ele['datetimepicker'](config).on('dp.change', e => {
      if (e.date !== this.date) {
        this.date = e.date;
        this.onChange.emit(e.date);
      }
    });
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/core/datepicker/datepicker.directive.ts